module.exports = __webpack_public_path__ + "static/img/img1.c19a02a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qmyd/qgz/img1.jpeg
// module id = gM27
// module chunks = 46